<template>
  <div id="schedule_report_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="vehiclePoolHeader" v-if="$route.params.id > 0">Update Schedule Report</span>
          <span class="page-title" id="vehiclePoolHeader" v-else>Add Schedule Report</span>
          <button type="submit" class="btn btn-secondary pull-right"
            v-on:click.prevent="BackScheduleReportList">
            <i class="fp-back"></i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content schedule-report-crud">
            <section class="internal-container border-top-table-fl">
                <form class="form-horizontal basic-form-container metric-form invoice-mapper" id="ScheduleReportForm">
                  <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                      <label class="control-label require" for="report">Select Report:</label>
                      <v-select
                        v-model="report"
                        name="report"
                        placeholder="Select Report."
                        label="text"
                        :options="reportNameArr"
                        @input="loadReportFilters()"
                      ></v-select>
                      <div class="field-error">{{report_error_msg}}</div>
                    </div>
                    <div class="col form-group">
                      <label class="control-label" for="label">Label:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="label"
                        id="label"
                        placeholder="Enter Label"
                        name="label"
                      />
                    </div>
                    <div class="col form-group">
                      <label class="control-label" for="subject">Subject:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="subject"
                        id="subject"
                        placeholder="Enter Subject"
                        name="subject"
                      />
                    </div>
                  </div>
                  <div class="form-row row-cols-md-2 row-cols-1">
                      <div class="col form-group">
                        <label class="control-label" for="body">Body:</label>
                        <template>
                            <vue-editor v-model="body" id="bodyeditor"></vue-editor>
                        </template>
                      </div>
                  </div>
                  <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                      <label class="control-label require" for="frequency">Frequency:</label>
                      <v-select
                        v-model="frequency"
                        name="frequency"
                        placeholder="Select Frequency."
                        label="text"
                        :options="frequencyArr"
                        @input="changeDateTime()"></v-select>
                      <div class="field-error">{{frequency_error_msg}}</div>
                    </div>
                    <div class="col form-group">
                      <label class="control-label" for="attachment_format">Attachment Format:</label>
                      <v-select
                        v-model="attachment_format"
                        name="attachment_format"
                        placeholder="Select Attachment Format."
                        label="text"
                        :options="attachmentArr"></v-select>
                      <div class="field-error">{{ attachment_error_msg }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label" for="subject">Attachment Name:</label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="attachment_name"
                                id="attachment_name"
                                placeholder="Enter Attachment Name"
                                name="attachment_name"/>
                    </div>
                    <div class="col form-group" v-if="showMonths==true">
                      <label class="control-label require" for="frequency">Months:</label>
                      <v-select
                        multiple
                        v-model="months"
                        name="hours"
                        placeholder="Select Months."
                        label="text"
                        :options="monthsArr"
                        class="invoice-multiple"></v-select>
                      <div class="field-error">{{month_error_msg}}</div>
                    </div>
                    <div class="col form-group" v-if="showDays==true">
                      <label class="control-label require" for="frequency">Days:</label>
                      <v-select
                        multiple
                        v-model="days"
                        name="hours"
                        placeholder="Select Days."
                        label="text"
                        :options="daysArr"
                        class="invoice-multiple"></v-select>
                      <div class="field-error">{{day_error_msg}}</div>
                    </div>
                    <div class="col form-group" v-if="showWeek==true">
                      <label class="control-label require" for="frequency">Days:</label>
                      <v-select
                        multiple
                        v-model="weekdays"
                        name="weekdays"
                        placeholder="Select Days."
                        label="text"
                        :options="weekArr"
                        class="invoice-multiple"></v-select>
                      <div class="field-error">{{week_error_msg}}</div>
                    </div>
                    <div class="col form-group" v-if="showHours==true">
                      <label class="control-label require" for="frequency">Hours:</label>
                      <v-select
                        multiple
                        v-model="hours"
                        name="hours"
                        placeholder="Select Hours."
                        label="text"
                        :options="hoursArr"
                        class="invoice-multiple"></v-select>
                      <div class="field-error">{{hour_error_msg}}</div>
                    </div>
                  </div>
                  <template v-if="moduleName!=''">
                    <data-table-filter-config
                      :moduleName="moduleName" :key="moduleName" ref="filterAllList" :allowSameFilter="'allow'" :fromSchedule="'schedule-report'">
                    ></data-table-filter-config>
                    <p style="color: red;" v-if="isSetStartDate==false">Start Date filter is required.</p>
                    <p style="color: red;" v-if="isSetEndDate==false">End Date filter is required.</p>
                  </template>
                  <div class="form-row row-cols-md-2 row-cols-1">
                      <div class="col form-group">
                        <label class="control-label" for="capacity">Recipient:</label>
                        <div v-for="(row,key) in emailRows" v-bind:key="key" class="form-group pull-left w-100">
                          <input
                            type="text"
                            class="form-control w-75 pull-left mr-2"
                            v-model="row.email"
                            id="email"
                            placeholder="Enter Email"
                            name="email"/>
                          <a v-on:click="removeElement(row);" class="cursor-pointer pull-left mt-2" v-if="emailRows.length > 1">
                            <i class="fp-delete color-red"></i>
                          </a>
                          <div style="clear:both;" class="field-error" v-if="row.emailError!=''">{{row.emailError}}</div>
                        </div>
                      </div>
                  </div>
                  <div class="btn-groups form-group">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="addRow">Add Email</button>
                  </div>
                  <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                      <label class="control-label">Enabled</label>
                      <div class="custome-radiobtn">
                        <div class="form-check form-check-inline">
                            <label class="boolean optional radio-custom" for="enable">
                              Yes
                              <input
                                type="radio"
                                v-model="enabled"
                                :value="1"
                                id="enable"
                                name="enabled"
                              />
                              <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <label class="boolean optional radio-custom" for="disable">
                              No
                              <input
                                type="radio"
                                v-model="enabled"
                                :value="0"
                                id="disable"
                                name="enabled"
                              />
                              <span class="checkmark"></span>
                            </label>
                        </div>
                      </div>
                      <div class="field-error"></div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <strong id="errorMsg" class="field-error"></strong>
                    </div>
                  </div>
                  <div class="btn-groups">
                      <button
                        type="submit"
                        id="createVehicleSchedulelBtn"
                        v-if="$route.params.id > 0"
                        class="btn btn-primary"
                        v-on:click.prevent="CreateScheduleReport"
                      >
                        <i class="fp-reload"></i> Update
                      </button>

                      <button
                        type="submit"
                        id="createScheduleReportBtn"
                        v-else
                        class="btn btn-primary"
                        v-on:click.prevent="CreateScheduleReport"
                      >
                        <i class="fp-save"></i> Save
                      </button>

                      <button
                        type="submit"
                        id="createAndContinueScheduleReportBtn"
                        v-if="$route.params.id == undefined"
                        class="btn btn-tertiary"
                        v-on:click.prevent="CreateScheduleReport(flag='Save and Continue')"
                      >
                        <i class="fp-save-continue"></i> Save and Continue
                      </button>

                      <button
                        type="submit"
                        id="cancelScheduleReportBtn"
                        class="btn btn-tertiary"
                        v-on:click.prevent="BackScheduleReportList"
                      >
                        <i class="fp-close"></i> Cancel
                      </button>
                  </div>
                  <!-- </div> -->
                </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment';
import { VueEditor } from "vue2-editor";
import fuelTicketDetailReport from "@/components/reports/FuelTicketDetailReport.vue";
import customerReport from "@/components/reports/CustomerReport.vue";
import equipmentMaster from "@/components/reports/EquipmentMaster.vue";
import unitPermitDetailReport from "@/components/reports/UnitPermitDetail.vue";
import insurancePolicyReport from "@/components/reports/InsurancePolicyReport.vue";
import customerRentalScopeRateReport from "@/components/reports/CustomerRentalScopeRateReport.vue";
import generalLedgerList from "@/components/accounting/reports/GeneralLedgerReport.vue";
import invoiceDetailReport from "@/components/reports/InvoiceDetailReport.vue";
import availableEquipment from "@/components/reports/AvailableEquipmentReport.vue";
import rentalUtilizeAssetList from "@/components/reports/RentalUtilizationEquipmentReport.vue";
import OwnedEquipmentReport from "@/components/reports/OwnedEquipmentReport.vue";
import leaseContractReport from "@/components/reports/LeaseContractReport.vue";
import customerAgedTrialBalanceSummary from "@/components/reports/CustomerAgedTrialBalanceSummary.vue";
import customerAgedTrialBalanceDetail from "@/components/reports/CustomerAgedTrialBalanceDetail.vue";
import agedTrialBalanceDetailGrid from  "@/components/reports/AgedTrialBalanceDetailGrid.vue";
import annualActualMetricVSContractMetric from '@/components/reports/AnnualActualMetricVSContractMetric.vue';
import apTrialBalanceAsAtDetail from '@/components/reports/APTrialBalanceAsAtDetail.vue';
import apVoucherDistributionEdit from '@/components/reports/APVoucherDistributionEdit.vue';
import arReceiptsAndApplications from '@/components/reports/ARReceiptsAndApplications.vue';
import contractRevenue from '@/components/reports/ContractRevenueReport.vue';
import debtNoteBalanceDetails from '@/components/DebtNoteBalanceReport.vue';
import debtNoteUnitDetail from '@/components/reports/DebtNoteUnitDetailReport.vue';
import depreciationNBVReport from '@/components/reports/DepreciationNBVAsAt.vue';
import depreciationReviewReport from '@/components/reports/DepreciationReviewReport.vue';
import disposalInvoiceReport from '@/components/reports/DisposalInvoiceReport.vue';
import equipmentCurrentStatus from '@/components/reports/EquipmentCurrentStatus.vue';
import assetFeatureReport from '@/components/AssetFeatureReport.vue';
import equipmentPoolTransfer from '@/components/reports/EquipmentPoolTransfer.vue';
import gangsheetReport from '@/components/reports/GangsheetReport.vue';
import inventoryReport from '@/components/reports/InventoryReport';
import laborManagementReport from '@/components/reports/LaborManagementReport.vue';
import leaseContractExpiryReport from '@/components/LeaseContractExpiryReport.vue';
import ltdUnitProfitAndLossSummary from '@/components/reports/LTDUnitProfitAndLossSummary.vue';
import metricsBilledReport from '@/components/reports/MetricsBilledReport.vue';
import notePadReviewReport from '@/components/reports/NotePadReviewReport.vue';
import openOnAccountCash from '@/components/reports/OpenOnAccountCash.vue';
import outOfServiceHistory from '@/components/reports/OutOfServiceHistory.vue';
import pmComplianceFacilityReport from '@/components/reports/PMComplianceFacilityReport.vue';
import pmCompliancePoolReport from '@/components/reports/PMCompliancePoolReport.vue';
import pmUnitDetailList from '@/components/reports/PMUnitDetailReport.vue';
import pmUnitForecastReport from '@/components/reports/PMUnitForecastReport.vue';
import rentalActivityReport from '@/components/reports/RentalActivityReport.vue';
import rentalActivityRatesReport from '@/components/reports/RentalActivityWithRatesReport.vue';
import rentalListing from '@/components/reports/RentalListingReport.vue';
import repairHistory from '@/components/reports/RepairHistoryReport.vue';
import reservationReport from '@/components/reports/ReservationReport.vue';
import subDayInPeriodReport from '@/components/reports/SubDayInPeriodReport.vue';
import nonBillableUnitReport from '@/components/reports/NonBillableUnitReport.vue';
import warrantyClaimReport from '@/components/WarrantyClaimReport.vue';
import weeklyRentalReport from '@/components/reports/WeeklyRentalReport.vue';
import EquipmentFeatureReport from '@/components/reports/EquipmentFeatureReport.vue';
// import dataTableFilterConfig from "@/components/ModuleFilterConfig.vue";
// const fuelTicketList = () => import('@/components/FuelTicketList')
import {dataTableMixins} from '../mixins/dataTableMixins';
import EventBus from "./event-bus";


var context;

export default {
  name: "ScheduleReportCreate",
  components: {
        
        VueEditor,
        // dataTableFilterConfig,
        // fuelTicketList: () => import('@/components/FuelTicketList'),
        fuelTicketDetailReport,
        customerReport,
        equipmentMaster,
        unitPermitDetailReport,
        insurancePolicyReport,
        customerRentalScopeRateReport,
        availableEquipment,
        generalLedgerList,
        invoiceDetailReport,
        leaseContractReport,
        rentalUtilizeAssetList,
        OwnedEquipmentReport,
        customerAgedTrialBalanceSummary,
        customerAgedTrialBalanceDetail,
        agedTrialBalanceDetailGrid,
        annualActualMetricVSContractMetric,
        apTrialBalanceAsAtDetail,
        apVoucherDistributionEdit,
        arReceiptsAndApplications,
        contractRevenue,
        debtNoteBalanceDetails,
        debtNoteUnitDetail,
        depreciationNBVReport,
        depreciationReviewReport,
        disposalInvoiceReport,
        equipmentCurrentStatus,
        assetFeatureReport,
        equipmentPoolTransfer,
        gangsheetReport,
        inventoryReport,
        laborManagementReport,
        leaseContractExpiryReport,
        ltdUnitProfitAndLossSummary,
        metricsBilledReport,
        notePadReviewReport,
        openOnAccountCash,
        outOfServiceHistory,
        pmComplianceFacilityReport,
        pmCompliancePoolReport,
        pmUnitForecastReport,
        rentalActivityReport,
        rentalActivityRatesReport,
        rentalListing,
        repairHistory,
        reservationReport,
        subDayInPeriodReport,
        nonBillableUnitReport,
        warrantyClaimReport,
        weeklyRentalReport,
        EquipmentFeatureReport
    },
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Schedule Report | " +process.env.COPYRIGHT_NAME : "Create Schedule Report | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    report: null,
    frequency: null,
    start_date_time:'',
    optionsDate: {
    format: 'MM/DD/YYYY HH:mm:ss',
//              useCurrent: true,
    //          minDate:moment().millisecond(0).second(0).minute(0).hour(0),//new Date(),
    showClose: true,
    },
    optionsTime: {
      // https://momentjs.com/docs/#/displaying/
      format: 'MM HH:mm:ss',
      useCurrent: true,
      showClear: true,
      showClose: true,
    },
    attachment_format:null,
    // recipient:"",
    enabled: 1,
    loading:false,
    report_error_msg: "",
    frequency_error_msg: "",
    start_date_time_error_msg: "",
    start_time_error_msg: "",
    start_time:"",
    // recipient_error_msg: "",
    attachment_error_msg: "",
    emailRows: [],
    // end_of_month:false,
    label:"",
    subject:"",
    body:"",
    attachment_name:"",
    hours:null,
    showHours:false,
    showWeek:false,
    showDays:false,
    showMonths:false,
    days:null,
    weekdays:null,
    months:null,
    hour_error_msg:"",
    day_error_msg:"",
    month_error_msg:"",
    week_error_msg:"",
    moduleName:"",
    columns:[],
    isSetStartDate:true,
    isSetEndDate:true,
    userColumns:[],
    reportId:"",
    columnConfig:[]
  }),
  beforeMount: function() {
      context = this;
  },
    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_schedule_report') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
    },
  created: function() {

  },
  mounted: function() {

        var self = this;
        self.getPermissions();
        self.emailRows.push({email: "",emailError:""});
        var userObj = JSON.parse(localStorage.getItem("user_obj"));

        if (userObj != null) {
            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
            var timeFormat = "MM,"+" "+userObj["time_format"];
            if (dateTimeFormat != null) {
    //              console.log(dateTimeFormat);
                //set date time format in optionsDate format of date picker
                self.optionsDate.format = self.getDateTimeFormat(dateTimeFormat);
                self.optionsTime.format = self.getDateTimeFormat(timeFormat);
            }
            //remove report drop down options on basis of username fleetpro@vvgtruck.com
            var userName = userObj['username'];
            var email = userObj['email'];
            if ((userName != null && userName != "fleetpro@vvgtruck.com") || (email != null && email != "fleetpro@vvgtruck.com")) {
              var reportArr = self.reportNameArr;
              var newReporrArr = [];
              for (var i = 0;i < reportArr.length;i++) {
                if (reportArr[i].value != 'unit test' && reportArr[i].value != 'automation test'
                  && reportArr[i].value != 'delete cpi pdf and html file' && reportArr[i].value != 'delete export'
                  && reportArr[i].value != 'clear debugbar') {
                  newReporrArr.push(reportArr[i]);
                }
              }
              self.reportNameArr = newReporrArr;
            }
        }

        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadScheduleReport();
        }
  },
  methods: {

    BackScheduleReportList() {
        var self = this;
        self.$router.push("/schedule-report/list");
    },
    loadReportFilters(){
        var self = this;
        self.columns=[];
        self.attachmentArr=[];

        if (self.report != null) {
          if(self.report.value=='fuel ticket detail'){
              self.moduleName='fuelTicketDetail';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var fuelticket = fuelTicketDetailReport.data().columns;
              self.columns=fuelticket;
          }else if(self.report.value=='customer listing'){
              self.moduleName='customerReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var customer=customerReport.data().columns;
              self.columns=customer;
          }else if(self.report.value=='equipment master'){
              self.moduleName='assetReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var asset=equipmentMaster.data().columns;
              self.columns=asset;
          }else if(self.report.value=='unit permit detail'){
              self.moduleName='unitPermitDetail';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var assetPermit=unitPermitDetailReport.data().columns;
              self.columns=assetPermit;
          }else if(self.report.value=='insurance policies'){
              self.moduleName='insurancePolicyReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var insurancePolicy=insurancePolicyReport.data().columns;
              self.columns=insurancePolicy;
          }else if(self.report.value=='customer rental scope rates'){
              self.moduleName='customerScopeRateReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var scopeRate=customerRentalScopeRateReport.data().columns;
              self.columns=scopeRate;
          }else if(self.report.value=='general ledger detail'){
              self.moduleName='generalLedgerReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var generalLedger=generalLedgerList.data().columns;
              self.columns=generalLedger;
          }else if(self.report.value=='invoice detail'){
              self.moduleName='invoiceDetailReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var invoiceCust=invoiceDetailReport.data().columns;
              self.columns=invoiceCust;
          }else if(self.report.value=='available equipment'){
              self.moduleName='availableEquipmentReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var availableAsset=availableEquipment.data().columns;
              self.columns=availableAsset;
          }else if(self.report.value=='lease contracts'){
              self.moduleName='leaseContractReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var availableContract=leaseContractReport.data().columns;
              self.columns=availableContract;
          }else if(self.report.value=='rental utilization equipment type detail'){
              self.moduleName='rentalUtilizationEquipment';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var availableAsset=rentalUtilizeAssetList.data().columns;
              self.columns=availableAsset;
          }else if(self.report.value=='owned equipment current values'){
              self.moduleName='ownedEquipment';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var availableAsset=OwnedEquipmentReport.data().columns;
              self.columns=availableAsset;
          }else if(self.report.value == 'aged trial balance - summary'){
              self.moduleName='customerAgedTrialBalance';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var agedTrialBal = customerAgedTrialBalanceSummary.data().columns;
              self.columns = agedTrialBal;
          }else if (self.report.value == 'aged trial balance detail as at') {
              self.moduleName='customerAgedTrialBalanceDetail';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var agedTrialBal = customerAgedTrialBalanceDetail.data().columns;
              self.columns = agedTrialBal;
          }else if (self.report.value == 'aged trial balance detail grid') {
              self.moduleName='agedTrialBalanceDetailGrid';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var agedTrialBalGrid = agedTrialBalanceDetailGrid.data().columns;
              self.columns = agedTrialBalGrid;
          }else if (self.report.value == 'annual actual metrics vs contract metrics') {
              self.moduleName='actualMetricVSContractMetric';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var annualActualMetric = annualActualMetricVSContractMetric.data().columns;
              self.columns = annualActualMetric;
          }else if (self.report.value == 'ap trial balance as at detail') {
              self.moduleName='apTrialBalanceAsAtDetail';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var apTrialBalance = apTrialBalanceAsAtDetail.data().columns;
              self.columns = apTrialBalance;
          }else if (self.report.value == 'ap voucher distribution edit') {
              self.moduleName='apVoucherDistribution';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var apVoucher = apVoucherDistributionEdit.data().columns;
              self.columns = apVoucher;
          }else if (self.report.value == 'ar receipts and applications') {
              self.moduleName='arReceiptsAndApplications';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var arReceipts = arReceiptsAndApplications.data().columns;
              self.columns = arReceipts;
          }else if (self.report.value == 'contract revenue detail') {
              self.moduleName='contractRevenue';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var contractRevenueRt = contractRevenue.data().columns;
              self.columns = contractRevenueRt;
          }else if (self.report.value == 'debt note balance details') {
              self.moduleName='debtNoteBalanceDetail';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var debtNoteBalance = debtNoteBalanceDetails.data().columns;
              self.columns = debtNoteBalance;
          }else if (self.report.value == 'debt note unit detail') {
              self.moduleName='debtNoteUnitDetailReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var debtNoteUnit = debtNoteUnitDetail.data().columns;
              self.columns = debtNoteUnit;
          }else if (self.report.value == 'depreciation nbv as at') {
              self.moduleName = 'depreciationNBVReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var depreciationNbv = depreciationNBVReport.data().columns;
              self.columns = depreciationNbv;
          }else if (self.report.value == 'depreciation review') {
              self.moduleName = 'depreciationReviewReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var depreciationReview = depreciationReviewReport.data().columns;
              self.columns = depreciationReview;
          }else if (self.report.value == 'disposal invoice listing') {
              self.moduleName = 'disposalInvoiceListing';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var disposalInvoice = disposalInvoiceReport.data().columns;
              self.columns = disposalInvoice;
          }else if (self.report.value == 'equipment current status') {
              self.moduleName = 'equipmentCurrentStatus';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var equipmentCurrentSts = equipmentCurrentStatus.data().columns;
              self.columns = equipmentCurrentSts;
          }else if (self.report.value == 'equipment features') {
              self.moduleName = 'assetFeatureList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var assetFeature = assetFeatureReport.data().columns;
              self.columns = assetFeature;
          }else if (self.report.value == 'equipment pool transfer') {
              self.moduleName = 'equipmentPoolTransfer';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var equipmentPool = equipmentPoolTransfer.data().columns;
              self.columns = equipmentPool;
          }else if (self.report.value == 'gangsheet details') {
              self.moduleName = 'gangsheetReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var gangsheet = gangsheetReport.data().columns;
              self.columns = gangsheet;
          }else if (self.report.value == 'inventory as at detail') {
              self.moduleName = 'inventoryReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var inventoryData = inventoryReport.data().columns;
              self.columns = inventoryData;
          }else if (self.report.value == 'labor management detail (rpt.params)') {
              self.moduleName = 'laborManagementReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var laborManagementData = laborManagementReport.data().columns;
              self.columns = laborManagementData;
          }else if (self.report.value == 'lease contract expiry report') {
              self.moduleName = 'leaseContractExpiry';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var leaseContractExpiry = leaseContractExpiryReport.data().columns;
              self.columns = leaseContractExpiry;
          }else if (self.report.value == 'ltd unit profit and loss summary') {
              self.moduleName = 'ltdUnitProfitLossSummary';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var ltdUnitProfitAndLoss = ltdUnitProfitAndLossSummary.data().columns;
              self.columns = ltdUnitProfitAndLoss;
          }else if (self.report.value == 'metrics billed (detail)') {
              self.moduleName = 'metricsBilledReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var metricsBilledDetail = metricsBilledReport.data().columns;
              self.columns = metricsBilledDetail;
          }else if (self.report.value == 'note pad review') {
              self.moduleName = 'notePadReview';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var notePadReview = notePadReviewReport.data().columns;
              self.columns = notePadReview;
          }else if (self.report.value == 'open on account cash') {
              self.moduleName = 'openOnAccountCash';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var openOnAccount = openOnAccountCash.data().columns;
              self.columns = openOnAccount;
          }else if (self.report.value == 'out of service history') {
              self.moduleName = 'outofserviceHistory';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var outOfService = outOfServiceHistory.data().columns;
              self.columns = outOfService;
          }else if (self.report.value == 'pm compliance - facility level') {
              self.moduleName = 'PMComplianceFacilityList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var pmComplianceFacility = pmComplianceFacilityReport.data().columns;
              self.columns = pmComplianceFacility;
          }else if (self.report.value == 'pm compliance - pool level') {
              self.moduleName = 'PMCompliancePoolList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var pmCompliancePool = pmCompliancePoolReport.data().columns;
              self.columns = pmCompliancePool;
          }else if (self.report.value == 'pm unit detail with history') {
              self.moduleName = 'PMUnitDetailList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var pmUnitDetail = pmUnitDetailList.data().columns;
              self.columns = pmUnitDetail;
          }else if (self.report.value == 'pm unit forecast') {
              self.moduleName = 'PMUnitForecastList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var pmUnitForecast = pmUnitForecastReport.data().columns;
              self.columns = pmUnitForecast;
          }else if (self.report.value == 'rental activity') {
              self.moduleName = 'rentalActivityReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var rentalActivity = rentalActivityReport.data().columns;
              self.columns = rentalActivity;
          }else if (self.report.value == 'rental activity with rates (sys parameters)') {
              self.moduleName = 'rentalActivityWithRatesReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var rentalActivityRates = rentalActivityRatesReport.data().columns;
              self.columns = rentalActivityRates;
          }else if (self.report.value == 'rental listing') {
              self.moduleName = 'rentalReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var rentalListingData = rentalListing.data().columns;
              self.columns = rentalListingData;
          }else if (self.report.value == 'repair history') {
              self.moduleName = 'repairHistory';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var repairHistoryData = repairHistory.data().columns;
              self.columns = repairHistoryData;
          }else if (self.report.value == 'reservation listing') {
              self.moduleName = 'reservationReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var reservationData = reservationReport.data().columns;
              self.columns = reservationData;
          }else if (self.report.value == 'sub days in period') {
              self.moduleName = 'SubDaysInPeriodReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var subDayInPeriod = subDayInPeriodReport.data().columns;
              self.columns = subDayInPeriod;
          }else if (self.report.value == 'velocity non billable units') {
              self.moduleName = 'nonBillableUnits';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var nonBillableUnits = nonBillableUnitReport.data().columns;
              self.columns = nonBillableUnits;
          }else if (self.report.value == 'warranty claim listing') {
              self.moduleName = 'warrantyClaimReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var warrantyClaimData = warrantyClaimReport.data().columns;
              self.columns = warrantyClaimData;
          }else if (self.report.value == 'weekly rental report') {
              self.moduleName = 'weeklyRentalReport';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var weeklyRentalData = weeklyRentalReport.data().columns;
              self.columns = weeklyRentalData;
          }else if (self.report.value == 'equipment feature report sys param') {
              self.moduleName = 'assetFeatureSysPrmList';
              self.attachmentArr=[{text:'Excel',value:'excel'}];
              var assetFeatureSysPrmList = EquipmentFeatureReport.data().columns;
              self.columns = assetFeatureSysPrmList;
          }
          else{
            self.attachmentArr=[{text:'Pdf',value:'pdf'},{text:'Excel',value:'excel'},{text:'Csv',value:'csv'}];
              self.moduleName='';
          }
        }else{
            self.attachmentArr=[{text:'Pdf',value:'pdf'},{text:'Excel',value:'excel'},{text:'Csv',value:'csv'}];
            self.moduleName='';
        }
    },
    changeDateTime(){
        var self = this;
        if (self.frequency != null || self.frequency.value!= null) {
            if(self.frequency.value=='daily'){
                self.showHours=true;
                self.showWeek=false;
                self.showDays=false;
                self.showMonths=false;
            }else if(self.frequency.value=='weekly'){
                self.showHours=true;
                self.showWeek=true;
                self.showDays=false;
                self.showMonths=false;
            }else if(self.frequency.value=='monthly'){
                self.showHours=true;
                self.showDays=true;
                self.showMonths=true;
                  self.showWeek=false;
            }else{
                self.showHours=false;
                self.showDays=false;
                self.showMonths=false;
                self.showWeek=false;
            }

        // if(self.frequency.value=='end of month')
        // {
        //     self.end_of_month=true;
        // }else{
        //         self.end_of_month=false;
        // }
        }else{
            // self.end_of_month=false;
            self.showHours=false;
            self.showDays=false;
            self.showMonths=false;
            self.showWeek=false;
        }
    },
    addRow: function () {
        var self = this;
        // if(self.emailRows.length < 5) {
            var index = self.emailRows.length - 1;
            if(self.emailRows[index].email != ""){
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!re.test(self.emailRows[index].email)){
                    self.emailRows[index].emailError = "Email is Invalid.";

                }else {
                    self.emailRows[index].emailError = "";
                    self.emailRows.push({email: "", emailError: ""});
                }
            }else{
                self.emailRows[index].emailError = "Email is Required.";
            }

        // }
    },
    removeElement: function (row) {
        var self = this;
        if(self.emailRows.length > 1) {
            var index = self.emailRows.indexOf(row);
            self.emailRows.splice(index, 1);
        }
    },
    checkStartDateEndateValidation: function() {
        var self = this;
        var error = false;
        self.isSetStartDate=false;
        self.isSetEndDate=false;
        for (var i=0; i<self.serverParams.columnFilters.length; i++) {

            var columnType = "";

            if ( self.serverParams.columnFilters[i].columnId != null ) {
                    if(self.serverParams.columnFilters[i].columnId.field=='start_date'){
                        self.isSetStartDate=true;
                    }
                    if(self.serverParams.columnFilters[i].columnId.field=='end_date'){
                          self.isSetEndDate=true;
                    }
            }
        }
        if(self.isSetStartDate==true && self.isSetEndDate==false){
            error=true;
        }else if(self.isSetStartDate==false && self.isSetEndDate==true)
        {
            error=true;
        }else{
            self.isSetStartDate=true;
            self.isSetEndDate=true;
        }

        return error;
    },
    CreateScheduleReport(flag) {
      var self = this;
      var error = false;
      EventBus.$emit('column-config-saved', "saved");
      self.loadFilters('reportFilter');
      var fieldsarr='';
      var action='export';

      // error=self.checkStartDateEndateValidation();

        if(self.report!=null){
          if(self.report.value=='fuel ticket'){
            error=self.checkStartDateEndateValidation();
          }
          if(self.report.value=='customer listing'){
              action='export';
              fieldsarr = {
                  page: self.serverParams.page,
                  perPage: 100,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  action:action,
                  selectedAll:self.serverParams.selectedAll,
              };
          }else if(self.report.value=='unit permit detail'){
              fieldsarr = {
                  page: self.serverParams.page,
                  perPage: 100,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  action:action,
                  selectedAll:self.serverParams.selectedAll,
              };
          }else if(self.report.value=='invoice detail'){
              fieldsarr = {
                  page: self.serverParams.page,
                  perPage: 100,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  action: action,
                  selectedAll:self.serverParams.selectedAll,
              };
          }else if (self.report.value == 'aged trial balance detail as at' || self.report.value == 'ap trial balance as at detail') {
              var selectedYear = "";
              var agingDate = "";
              if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                  if (self.serverParams.columnFilters[i] != undefined) {
                      if (self.serverParams.columnFilters[i] != null) {
                          if (self.serverParams.columnFilters[i].columnId != null) {
                              if (self.serverParams.columnFilters[i].columnId.field != null) {
                                  if (self.serverParams.columnFilters[i].columnId.fpFieldType == "year") {
                                      selectedYear = self.serverParams.columnFilters[i].filterValue;
                                  }
                                  if (self.serverParams.columnFilters[i].columnId.field == "aging_date") {
                                      agingDate = self.serverParams.columnFilters[i].filterValue;
                                  }
                              }
                          }
                      }
                  }
                }
              }
              fieldsarr = {
                page: self.serverParams.page,
                perPage: 100,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: action,
                all: self.serverParams.selectedAll,
                year:selectedYear,
                agingDate:agingDate
              };
          }else if (self.report.value == 'ap voucher distribution edit') {
            var includePaymentInfo = "";

            if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                    if (self.serverParams.columnFilters[i].columnId.field == "include_payment_info") {
                                        includePaymentInfo = self.serverParams.columnFilters[i].filterOptionValue.value;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:action,
                paymentFlag:includePaymentInfo
            };
          }else if (self.report.value == 'general ledger detail') {
            var sortObj = {field:"post_date",type:"desc"};
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: sortObj,
                action:action,
                paymentFlag:includePaymentInfo
            };
          }else if (self.report.value == 'pm compliance - facility level') {
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:action,
                from:'facility'
            };
          }else if (self.report.value == 'pm compliance - pool level') {
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:action,
                from:'pool'
            };
          }else if (self.report.value == 'rental activity') {
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:action,
                from: "rentalActivity"
            };
          }else if (self.report.value == 'rental activity with rates (sys parameters)') {
            fieldsarr = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:action,
                from: "rates"
            };
          }else {
              fieldsarr = {
                  page: self.serverParams.page,
                  perPage: 100,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  action: action,
                  all: self.serverParams.selectedAll,
              };
          }
        }else {
            fieldsarr = {
                page: self.serverParams.page,
                perPage: 100,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: action,
                all: self.serverParams.selectedAll,
            };
        }
       var hoursArr = [];
       var monthsArr = [];
       var daysArr = [];
       var weekArr = [];

        if(self.hours != null && self.hours.length > 0){
            for(var i = 0; i < self.hours.length; i++){
                hoursArr.push(self.hours[i].value);
            }
        }
         if(self.months != null && self.months.length > 0){
            for(var i = 0; i < self.months.length; i++){
                monthsArr.push(self.months[i].value);
            }
        }
         if(self.days != null && self.days.length > 0){
            for(var i = 0; i < self.days.length; i++){
                daysArr.push(self.days[i].value);
            }
        }
        if(self.weekdays != null && self.weekdays.length > 0){
            for(var i = 0; i < self.weekdays.length; i++){
                weekArr.push(self.weekdays[i].value);
            }
        }


        self.report_error_msg= "";
        self.frequency_error_msg= "";
        self.start_date_time_error_msg= "";
        self.start_time_error_msg="";
        self.attachment_format_error_msg= "";
        self.recipient_error_msg= "";
        self.hour_error_msg="";
        self.day_error_msg="";
        self.month_error_msg="";
        self.week_error_msg="";

     if (self.report == null || !self.report.value) {
          self.report_error_msg = "Report Required.";
          error = true;
      }
     if (self.frequency == null || !self.frequency.value) {
          self.frequency_error_msg = "Frequency Required.";
          error = true;
      }else{
          if(self.frequency.value=='daily'){
              if (self.hours == null || self.hours.length <= 0) {
                self.hour_error_msg = "Hours Required.";
                error = true;

             }
          }
          if(self.frequency.value=='weekly'){
              if (self.hours == null || self.hours.length <= 0) {
                self.hour_error_msg = "Hours Required.";
                error = true;

             }
             if (self.weekdays == null || self.weekdays.length <= 0) {
                self.week_error_msg = "Days Required.";
                error = true;

             }
          }
          if(self.frequency.value=='monthly'){
               if (self.hours == null || self.hours.length <= 0) {
                self.hour_error_msg = "Hours Required.";
                error = true;

             }
             if (self.days == null || self.days.length <= 0) {
                self.day_error_msg = "Days Required.";
                error = true;

             }
              if (self.months == null || self.months.length <= 0) {
                self.month_error_msg = "Months Required.";
                error = true;

             }
          }

      }



    //  if (self.attachment_format == null || !self.attachment_format.value) {
    //       self.attachment_error_msg = "Attachment Format Required.";
    //       error = true;
    //   }

    //  if(self.end_of_month==false){
    //     if (!self.start_date_time || self.start_date_time == null || self.start_date_time == "") {
    //         self.start_date_time_error_msg = "Starting Date Time Required.";
    //         error = true;
    //     }else{
    //            var getDateVal = new Date(self.start_date_time);
    //            var dateVal=getDateVal.getDate();
    //            if(self.frequency.value == 'monthly' && (dateVal==29 || dateVal==30 || dateVal==31))
    //            {
    //                 self.start_date_time_error_msg = "Please Select any Date Before 29th.";
    //                  error = true;
    //            }

    //     }
    //   }

    //  if(self.end_of_month==true){
    //       if (!self.start_time || self.start_time == null || self.start_time == "") {
    //          self.start_time_error_msg = "Starting Time Required.";
    //          error = true;
    //       }else{
    //           self.start_date_time=self.start_time;
    //       }
    //  }
        if(self.emailRows.length >1){
            for(var i=0;i<self.emailRows.length;i++)
            {
                    if(self.emailRows[i].email=="")
                    {
                        self.emailRows[i].emailError = "Email is Required.";
                        error=true;
                    }else{
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!re.test(self.emailRows[i].email)){
                            self.emailRows[i].emailError = "Email is Invalid.";
                            error=true;
                        }
                    }
            }
        }

      if (!error) {
        self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createScheduleReportBtn").val("Updating ...");
                $("#createScheduleReportBtn").prop("disabled", true);
                $("#cancelScheduleReportBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueScheduleReportBtn").val("Saving ...");
                    $("#createScheduleReportBtn").prop("disabled", true);
                    $("#createAndContinueScheduleReportBtn").prop("disabled", true);
                    $("#cancelScheduleReportBtn").prop("disabled",true);

                }else{

                    $("#createScheduleReportBtn").val("Saving ...");
                    $("#createScheduleReportBtn").prop("disabled", true);
                    $("#createAndContinueScheduleReportBtn").prop("disabled", true);
                    $("#cancelScheduleReportBtn").prop("disabled",true);
                }

            }
             var fields = $('#ScheduleReportForm').serializeArray();
             var scheduleTime=[];
            fields.push({name: "report_name", value: self.report.value});

//            fields.push({name: "start_date_time", value: self.start_date_time});
            fields.push({name: "frequency", value: self.frequency.value});
            if (self.attachment_format == null || !self.attachment_format.value) {
                fields.push({ name: "attachment_format", value: "" });
            }else{
                fields.push({ name: "attachment_format", value: self.attachment_format.value});
            }
            if(self.emailRows.length >0){
                 fields.push({name: "recipient", value: JSON.stringify(self.emailRows)});
            }else{
                 fields.push({name: "recipient", value: ''});
            }
            fields.push({name: "body", value: self.body});
            var scheduleArr =null;

            if(self.frequency.value=='daily'){
               scheduleArr={hours:hoursArr};
            }
            if(self.frequency.value=='weekly'){
               scheduleArr={hours:hoursArr,days:weekArr};

            }
            if(self.frequency.value=='monthly'){
               scheduleArr={hours:hoursArr,days:daysArr,months:monthsArr};
            }

            fields.push({name: "filters", value: JSON.stringify(fieldsarr)});

            fields.push({name: "schedule_time", value: JSON.stringify(scheduleArr)});

            if (self.reportId != null && self.reportId != "") {
              fields.push({name: "id", value: self.reportId});
            }else{
              fields.push({name: "id", value: segments[3]});
            }
            fields.push({name: "columns", value: JSON.stringify(self.userColumns)});

            fields.push({name: "sort", value: JSON.stringify(self.serverParams.sort)});

            $.ajax({
                url: process.env.ROOT_API + "/schedule-report/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createScheduleReportBtn").val("Update");
                        $("#createScheduleReportBtn").prop("disabled", false);
                        $("#cancelScheduleReportBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueScheduleReportBtn").val("Save and Continue");
                            $("#createScheduleReportBtn").prop("disabled", false);
                            $("#createAndContinueScheduleReportBtn").prop("disabled", false);
                            $("#cancelScheduleReportBtn").prop("disabled",false);

                        }else{

                            $("#createScheduleReportBtn").val("Save");
                            $("#createScheduleReportBtn").prop("disabled", false);
                            $("#createAndContinueScheduleReportBtn").prop("disabled", false);
                            $("#cancelScheduleReportBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ScheduleReportForm").trigger("reset");
                            self.report= null;
                            self.frequency= null;
//                            self.start_date_time='';
                            self.attachment_format=null;
                            self.emailRows=[];
                            self.enabled= 1;
                            self.label="";
                            self.subject="";
                            self.body="";
                            self.hours=null;
                            self.showHours=false;
                            self.showWeek=false;
                            self.showDays=false;
                            self.showMonths=false;
                            self.days=null;
                            self.weekdays=null;
                            self.months=null;
                            self.attachment_name="";

                        }else if (flag == "Save Column Config") {
                          self.reportId = data.content.id;
                          EventBus.$emit('column-config-saved',"saved");
                        }else{
                            self.$router.push("/schedule-report/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createScheduleReportBtn").val("Update");
                        $("#createScheduleReportBtn").prop("disabled", false);
                        $("#cancelScheduleReportBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ScheduleReportForm").trigger("reset");


                            $("#createAndContinueScheduleReportBtn").val("Save and Continue");
                            $("#createScheduleReportBtn").prop("disabled", false);
                            $("#createAndContinueScheduleReportBtn").prop("disabled", false);
                            $("#cancelScheduleReportBtn").prop("disabled",false);

                        }else{

                            $("#createScheduleReportBtn").val("Save");
                            $("#createScheduleReportBtn").prop("disabled", false);
                            $("#createAndContinueScheduleReportBtn").prop("disabled", false);
                            $("#cancelScheduleReportBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'schdeule-report-create')
                }
            });
      }else{
                self.errorValidationFocus();
      }
    },
    loadScheduleReport() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/schedule-report/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                     self.reportId = data.content.id;
                     self.report= null;
                            self.frequency= null;
//                            self.start_date_time='';
                            self.attachment_format=null;
                            self.recipient="";
                            self.enabled= 1;
                            if(data.content.report_name!='' && data.content.report_name!=null){
                                 if (data.content.report_name == 'ap payment upload / outstanding ap') {
                                   self.report = {text:"AP Payment Upload / Outstanding AP",value:data.content.report_name};
                                 }else if (data.content.report_name == 'depreciation nbv as at') {
                                   self.report = {text:"Depreciation NBV As At",value:data.content.report_name};
                                 }else if (data.content.report_name == 'ltd unit profit and loss summary') {
                                   self.report = {text:"LTD Unit Profit And Loss Summary",value:data.content.report_name};
                                 }else if (data.content.report_name == 'pm compliance - facility level') {
                                   self.report = {text:"PM Compliance - Facility Level",value:data.content.report_name};
                                 }else if (data.content.report_name == 'pm compliance - pool level') {
                                   self.report = {text:"PM Compliance - Pool Level",value:data.content.report_name};
                                 }else if (data.content.report_name == 'pm unit detail with history') {
                                   self.report = {text:"PM Unit Detail With History",value:data.content.report_name};
                                 }else if (data.content.report_name == 'pm unit forecast') {
                                   self.report = {text:"PM Unit Forecast",value:data.content.report_name};
                                 }else{
                                   self.report = {text:self.ucString(data.content.report_name),value:data.content.report_name};
                                 }
                            }else{
                                self.report= null;
                            }
                            if(data.content.attachment_format!='' && data.content.attachment_format!=null){
                                 self.attachment_format = {text:self.titleCase(data.content.attachment_format),value:data.content.attachment_format};
                            }else{
                                self.attachment_format= null;
                            }
                            if(data.content.frequency!='' && data.content.frequency!=null){
                                 self.frequency = {text:self.titleCase(data.content.frequency),value:data.content.frequency};
                            }else{
                                self.frequency= null;
                            }

                            self.label=data.content.label;
                            self.body=data.content.body;
                            self.subject=data.content.subject;
                            self.attachment_name=data.content.attachment_name;

                            // if(data.content.frequency=='end of month'){

                            //     self.start_time=data.content.start_date_time;
                            //     self.changeDateTime();
                            // }else{
                            //     self.start_date_time=data.content.start_date_time;
                            // }

                            self.emailRows= data.content.receipient;
                            console.log(self.emailRows);
                            if(data.content.enabled=='yes'){
                                self.enabled=1;
                            }else{
                                self.enabled=0;
                            }
                            if (data.content.columns != undefined && data.content.columns != null && data.content.columns != "") {
                              self.columnConfig = data.content.columns;
                            }
                            self.loadReportFilters();

                            self.adjustFilter(data.content.filters.filters);
                            // setTimeout(function(){
                            // // EventBus.$emit('load-report-filters', data.content.filters.filters);
                            // EventBus.$emit('default-filter-load', data.content.filters.filters);

                            // },500);

                        var scheduleData=JSON.parse(data.content.schedule_time);
                            self.changeDateTime();
                            self.hours=[];
                            self.days=[];
                            self.months=[];
                            self.weekdays=[];
                            if(data.content.frequency=='daily'){
                                 for(var i = 0; i < scheduleData.hours.length; i++){
                                     self.hours.push({ text:self.titleCase(scheduleData.hours[i]),value:scheduleData.hours[i]});
                                }

                            }else if(data.content.frequency=='weekly')
                            {
                                 for(var i = 0; i < scheduleData.hours.length; i++){

                                     self.hours.push({ text:self.titleCase(scheduleData.hours[i]),value:scheduleData.hours[i]});
                                }
                                for(var i = 0; i < scheduleData.days.length; i++){

                                     self.weekdays.push({ text:self.titleCase(scheduleData.days[i]),value:scheduleData.days[i]});
                                }

                            }else if(data.content.frequency=='monthly')
                            {
                                for(var i = 0; i < scheduleData.hours.length; i++){

                                     self.hours.push({ text:self.titleCase(scheduleData.hours[i]),value:scheduleData.hours[i]});
                                }
                                for(var i = 0; i < scheduleData.days.length; i++){

                                     self.days.push({ text:self.titleCase(scheduleData.days[i]),value:scheduleData.days[i]});
                                }
                                 for(var i = 0; i < scheduleData.months.length; i++){

                                     self.months.push({ text:self.titleCase(scheduleData.months[i]),value:scheduleData.months[i]});
                                }
                            }
                        //column config load on update schedule report
                        setTimeout(function(){
                          EventBus.$emit('column-config-load-report', data.content.columns);
                        },500);
                }

            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'schedule-report-by-id')
            }
        });
    },

    adjustFilter:function(filterArr){
      var self = this;
      var duplicateCheckArr = [];
      if (filterArr && filterArr.length > 0){
        for(var i=0;i<filterArr.length;i++){
            if (filterArr[i].columnId){
                var columnType = filterArr[i].columnId.fpFieldType;

                if( columnType == "date" || columnType == "aging_date"){
                    if (filterArr[i].filterType != null ) {
                        /*if(filterArr[i].filterType.value == 'between'){

                            if (filterArr[i].dupflag && filterArr[i].dupflag == 'true'){
                              if (filterArr[i].filterDupValue && filterArr[i].filterDupValue.length){
                                var obj = filterArr[i];
                                var valArr = filterArr[i].filterDupValue;
                                var stringObj = '';
                                for(var l=0;l<valArr.length;l++){
                                  var newObj = obj;
                                  var val = '';
                                  val = valArr[l].value;
                                  self.$set(newObj, 'filterDateRangeValue', null);
                                  // obj.filterValue = filterArr[i].filterDupValue[l];
                                  self.$set(newObj, 'filterDateRangeValue', val);

                                  if (stringObj == ''){
                                    stringObj = JSON.stringify(newObj);
                                  }else{
                                    stringObj += '|'+JSON.stringify(newObj);
                                  }
                                }

                                if (stringObj != ''){
                                  var strArr = stringObj.split('|');

                                  if (strArr && strArr.length){
                                    for(var j = 0;j<strArr.length;j++){
                                      duplicateCheckArr.push(JSON.parse(strArr[j]));
                                    }
                                  }
                                }
                              }

                            }else{
                              // alert('herer');
                              duplicateCheckArr.push(filterArr[i]);

                            }

                        }else{
                            if (filterArr[i].dupflag && filterArr[i].dupflag == 'true'){
                              if (filterArr[i].filterDupValue && filterArr[i].filterDupValue.length){
                                var obj = filterArr[i];
                                var valArr = filterArr[i].filterDupValue;
                                var stringObj = '';
                                for(var l=0;l<valArr.length;l++){
                                  var newObj = obj;
                                  var val = '';
                                  val = valArr[l].value;
                                  self.$set(newObj, 'filterDateValue', null);
                                  // obj.filterValue = filterArr[i].filterDupValue[l];
                                  self.$set(newObj, 'filterDateValue', val);

                                  if (stringObj == ''){
                                    stringObj = JSON.stringify(newObj);
                                  }else{
                                    stringObj += '|'+JSON.stringify(newObj);
                                  }
                                }

                                if (stringObj != ''){
                                  var strArr = stringObj.split('|');

                                  if (strArr && strArr.length){
                                    for(var j = 0;j<strArr.length;j++){
                                      duplicateCheckArr.push(JSON.parse(strArr[j]));
                                    }
                                  }
                                }
                              }

                            }else{
                              // alert('herer');
                              duplicateCheckArr.push(filterArr[i]);

                            }
                        }*/
                      if(filterArr[i].filterType.value == 'between'){
                        var exist = false;

                        var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                        if (havInd != undefined && havInd != null){
                          var indNew = duplicateCheckArr.indexOf(havInd);
                          var valArr = filterArr[indNew].filterDupValue;

                          valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                          filterArr[indNew].filterDupValue = valArr;
                          filterArr[indNew].dupflag = 'true';
                          exist = true;

                          duplicateCheckArr.push(filterArr[i]);

                        }
                        if (!exist){
                          var valArr = [];
                          valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                          filterArr[i].filterDupValue = valArr;
                          duplicateCheckArr.push(filterArr[i]);
                        }
                      }else{
                        var exist = false;
                        var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                        if (havInd != undefined && havInd != null){
                            var indNew = duplicateCheckArr.indexOf(havInd);
                            var valArr = filterArr[indNew].filterDupValue;

                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                            filterArr[indNew].filterDupValue = valArr;
                            filterArr[indNew].dupflag = 'true';
                            exist = true;

                            duplicateCheckArr.push(filterArr[i]);

                        }
                        if (!exist){
                            var valArr = [];
                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                            filterArr[i].filterDupValue = valArr;
                            duplicateCheckArr.push(filterArr[i]);
                        }
                      }
                    }

                }
                if( columnType == "option" ){
                    if (filterArr[i].filterType != null ) {

                        /*if (filterArr[i].dupflag && filterArr[i].dupflag == 'true'){
                          if (filterArr[i].filterDupValue && filterArr[i].filterDupValue.length){
                            var obj = filterArr[i];
                            var valArr = filterArr[i].filterDupValue;
                            var stringObj = '';
                            for(var l=0;l<valArr.length;l++){
                              var newObj = obj;
                              var val = '';
                              val = valArr[l].value;
                              self.$set(newObj, 'filterOptionValue', null);
                              // obj.filterValue = filterArr[i].filterDupValue[l];
                              self.$set(newObj, 'filterOptionValue', val);

                              if (stringObj == ''){
                                stringObj = JSON.stringify(newObj);
                              }else{
                                stringObj += '|'+JSON.stringify(newObj);
                              }
                            }

                            if (stringObj != ''){
                              var strArr = stringObj.split('|');

                              if (strArr && strArr.length){
                                for(var j = 0;j<strArr.length;j++){
                                  duplicateCheckArr.push(JSON.parse(strArr[j]));
                                }
                              }
                            }
                          }

                        }else{
                          // alert('herer');
                          duplicateCheckArr.push(filterArr[i]);

                        }*/
                        //as per multiple filter changes
                        var exist = false;
                        var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);
                        if (havInd != undefined && havInd != null){
                            var indNew = duplicateCheckArr.indexOf(havInd);
                            var valArr = filterArr[indNew].filterDupValue;
                            valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                            filterArr[indNew].filterDupValue = valArr;
                            filterArr[indNew].dupflag = 'true';
                            exist = true;

                            duplicateCheckArr.push(filterArr[i]);

                        }
                        if (!exist){
                          var valArr = [];
                          valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                          filterArr[i].filterDupValue = valArr;
                          duplicateCheckArr.push(filterArr[i]);
                        }
                    }
                }
                if( columnType == "text" || columnType == "integer" || columnType == 'year' || columnType == 'period'){

                    if (filterArr[i].filterType != null ) {

                      /*if (filterArr[i].dupflag && filterArr[i].dupflag == 'true'){
                        if (filterArr[i].filterDupValue && filterArr[i].filterDupValue.length){
                          var obj = filterArr[i];
                          var valArr = filterArr[i].filterDupValue;
                          var stringObj = '';
                          for(var l=0;l<valArr.length;l++){
                            var newObj = obj;
                            var val = '';
                            val = valArr[l].value;
                            self.$set(newObj, 'filterValue', null);
                            // obj.filterValue = filterArr[i].filterDupValue[l];
                            self.$set(newObj, 'filterValue', val);

                            if (stringObj == ''){
                              stringObj = JSON.stringify(newObj);
                            }else{
                              stringObj += '|'+JSON.stringify(newObj);
                            }
                          }

                          if (stringObj != ''){
                            var strArr = stringObj.split('|');

                            if (strArr && strArr.length){
                              for(var j = 0;j<strArr.length;j++){
                                duplicateCheckArr.push(JSON.parse(strArr[j]));
                              }
                            }
                          }
                        }

                      }else{
                        // alert('herer');
                        duplicateCheckArr.push(filterArr[i]);

                      }*/
                      //as per multiple filter changes
                      var exist = false;
                      var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);
                      if (havInd != undefined && havInd != null){
                        var indNew = duplicateCheckArr.indexOf(havInd);
                        var valArr = filterArr[indNew].filterDupValue;
                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                        filterArr[indNew].filterDupValue = valArr;
                        filterArr[indNew].dupflag = 'true';
                        exist = true;
                        duplicateCheckArr.push(filterArr[i]);
                      }

                      if (!exist){
                        var valArr = [];
                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                        filterArr[i].filterDupValue = valArr;
                        duplicateCheckArr.push(filterArr[i]);
                      }

                    }
                }
                //custom date filter type
                if (columnType == "custom_date") {
                  if (filterArr[i].filterType != null ) {
                    if(filterArr[i].filterType.value == 'between' || filterArr[i].filterType.value == 'not between'){
                      var exist = false;
                      var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                      if (havInd != undefined && havInd != null){
                        var indNew = duplicateCheckArr.indexOf(havInd);
                        var valArr = filterArr[indNew].filterDupValue;

                        valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                        filterArr[indNew].filterDupValue = valArr;
                        filterArr[indNew].dupflag = 'true';
                        exist = true;

                        duplicateCheckArr.push(filterArr[i]);

                      }
                      if (!exist){
                        var valArr = [];
                        valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                        filterArr[i].filterDupValue = valArr;
                        duplicateCheckArr.push(filterArr[i]);
                      }
                    }else if (filterArr[i].filterType.value == 'IS NULL' || filterArr[i].filterType.value == 'IS NOT NULL') {
                      var exist = false;
                      var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                      if (havInd != undefined && havInd != null){
                          var indNew = duplicateCheckArr.indexOf(havInd);
                          var valArr = filterArr[indNew].filterDupValue;

                          valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                          filterArr[indNew].filterDupValue = valArr;
                          filterArr[indNew].dupflag = 'true';
                          exist = true;

                          duplicateCheckArr.push(filterArr[i]);

                      }
                      if (!exist){
                          var valArr = [];
                          valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                          filterArr[i].filterDupValue = valArr;
                          duplicateCheckArr.push(filterArr[i]);
                      }
                    }else if (filterArr[i].filterType.value == 'duration') {
                      var exist = false;

                      var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                      if (havInd != undefined && havInd != null){
                        var indNew = duplicateCheckArr.indexOf(havInd);
                        var valArr = filterArr[indNew].filterDupValue;

                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                        filterArr[indNew].filterDupValue = valArr;
                        filterArr[indNew].dupflag = 'true';
                        exist = true;

                        duplicateCheckArr.push(filterArr[i]);

                      }
                      if (!exist){
                        var valArr = [];
                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                        filterArr[i].filterDupValue = valArr;
                        duplicateCheckArr.push(filterArr[i]);
                      }
                    }else{
                       var exist = false;
                       var havInd = duplicateCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                       if (havInd != undefined && havInd != null){
                          var indNew = duplicateCheckArr.indexOf(havInd);
                          var valArr = filterArr[indNew].filterDupValue;
                          valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                          filterArr[indNew].filterDupValue = valArr;
                          filterArr[indNew].dupflag = 'true';
                          exist = true;

                          duplicateCheckArr.push(filterArr[i]);

                       }
                       if (!exist){
                          var valArr = [];
                          valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                          filterArr[i].filterDupValue = valArr;
                          duplicateCheckArr.push(filterArr[i]);
                       }
                    }
                  }
                }
            }

        }

        console.log(duplicateCheckArr);
        setTimeout(function(){
          EventBus.$emit('default-filter-load',duplicateCheckArr);
        },1500);
    }
    },
    removeScheduleConfig() {
      var self = this;
      if (self.reportId != null && self.reportId != "") {
        $.ajax({
          url: process.env.ROOT_API + "/schedule-report/config/remove",
          type: "POST",
          data:{id:self.reportId},
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
              self.loading = false;
              if (data.status == "success") {
                self.columnConfig = [];
                EventBus.$emit('column-config-removed','remove');
              }
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,false,'sch-report-remove-config')
          }
      });
      }else{
        EventBus.$emit('column-config-removed','remove');
      }
    }
  }
};
//save-column-config
EventBus.$on('save-column-config', function ( configData ) {
  context.userColumns = configData;
});
//remove-column-config
EventBus.$on('remove-column-config', function ( flag ) {
  context.removeScheduleConfig();
});
</script>
<style scoped>
.right-adjust {
  width: 50% !important;
  float: right;
  height: 38px;
  padding-right: 8px;
  border-bottom: 1px solid !important;
  border-bottom-color: #8080802e !important;
}
.overClass {
  overflow: visible;
}
.check-error {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleReportCreate.vue